import { isPathSegment } from '../../../../http/server/path.ts';
import { PathElement } from './path-element.ts';
import { MatchingContext } from '../path-pattern.ts';

/*internal*/ export class SingleCharWildcardedPathElement extends PathElement {
    readonly #text: Uint16Array;
    readonly #len: number;
    readonly #questionMarkCount: number;
    readonly #caseSensitive: boolean;

    constructor(pos: number, literalText: Uint16Array, questionMarkCount: number, caseSensitive: boolean, separator: number) {
        super(pos, separator);
        this.#len = literalText.length;
        this.#questionMarkCount = questionMarkCount;
        this.#caseSensitive = caseSensitive;
        if (caseSensitive) {
            this.#text = literalText;
        }
        else {
            this.#text = new Uint16Array(literalText.length);
            for (let i = 0; i < literalText.length; i++) {
                this.#text[i] = String.fromCharCode(literalText[i]).toLowerCase().charCodeAt(0);
            }
        }
    }

    matches(pathIndex: number, matchingContext: MatchingContext): boolean {
        if (pathIndex >= matchingContext.pathLength) {
            // no more path left to match this element
            return false;
        }

        const element = matchingContext.pathElements[pathIndex];
        if (!isPathSegment(element)) {
            return false;
        }

        const value = element.valueToMatch;
        if (value.length !== this.#len) {
            // not enough data to match this path element
            return false;
        }
        if (this.#caseSensitive) {
            for (let i = 0; i < this.#len; i++) {
                const c = this.#text[i];
                if ((c !== '?'.charCodeAt(0)) && (c !== value.charCodeAt(i))) {
                    return false;
                }
            }
        }
        else {
            for (let i = 0; i < this.#len; i++) {
                const c = this.#text[i];
                if ((c !== '?'.charCodeAt(0)) && (c !== String.fromCharCode(value.charCodeAt(i)).toLowerCase().charCodeAt(0))) {
                    return false;
                }
            }
        }

        pathIndex++;
        if (this.noMorePattern()) {
            if (matchingContext.determinedRemainingPath) {
                matchingContext.remainingPathIndex = pathIndex;
                return true;
            }
            else {
                return (pathIndex === matchingContext.pathLength);
            }
        }
        else {
            return (this.next !== undefined && this.next.matches(pathIndex, matchingContext));
        }
    }

    get wildcardCount(): number {
        return this.#questionMarkCount;
    }

    get normalizedLength() {
        return this.#len;
    }

    get chars() {
        return this.#text;
    }

    toString() {
        return `SingleCharWildcarded(${String.fromCharCode(...(this.#text))})`;
    }
}
